import React from "react";
import InnerLayout from "./InnerLayout";

const PrincipalsMessage = () => (
  <InnerLayout
    title="Principal's Message"
    image="/Campus/hero.jpg"
    breadcrumbs={[
      { label: "About", to: "/about" },
      { label: "Principal's Message" },
    ]}
  >
    <div className="flex flex-col md:flex-row gap-8 items-start">
      <div className="md:w-64 flex-shrink-0">
        <div className="aspect-[3/4] overflow-hidden bg-surface">
          <img
            src="/hero_images/VAKulkarni.jpg"
            alt="Dr. V. A. Kulkarni"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="mt-3">
          <p className="text-brand font-semibold text-lg">
            Dr. Vadiraj. A. Kulkarni
          </p>
          <p className="text-[#3a3a3a] italic text-sm">
            Professor and Principal
          </p>
          <p className="text-[#3a3a3a]/70 text-xs mt-1">
            Dept. of Electrical and Electronics Engg.
          </p>
        </div>
      </div>

      <div className="flex-1 vdit-prose">
        <p>
          Established in <strong>2004</strong>, <strong>KLS VDIT</strong> is a
          premier engineering and research institution offering{" "}
          <strong>7 Undergraduate Programs</strong>,{" "}
          <strong>2 Postgraduate Programs</strong>, and{" "}
          <strong>7 VTU-Recognized Research Centres</strong>, serving{" "}
          <strong>1,800+ students</strong>.
        </p>
        <p>
          The institute has enabled <strong>3,000+ skill certifications</strong>{" "}
          in the last five years through leading platforms such as{" "}
          <strong>Cisco</strong>, <strong>Infosys Springboard</strong>,{" "}
          <strong>MongoDB</strong>, <strong>IIT Bombay Spoken Tutorials</strong>
          , <strong>ICT Academy</strong>, and <strong>TCS iON</strong>, ensuring
          industry-ready learning.
        </p>
        <p>
          KLS VDIT has secured{" "}
          <strong>₹1.5+ Crore in research funding</strong> from{" "}
          <strong>K-Tech NAIN</strong>, <strong>AICTE IDEA Lab</strong>,{" "}
          <strong>VGST</strong>, and <strong>LEAP</strong>. The institute's
          vibrant research ecosystem, comprising{" "}
          <strong>12 research guides</strong> and <strong>35 scholars</strong>,
          has produced <strong>100+ research publications</strong>,{" "}
          <strong>31 published patents</strong>,{" "}
          <strong>2 granted patents</strong>, and{" "}
          <strong>115+ book chapters</strong>.
        </p>
        <p>
          The institution is committed to sustainability through a{" "}
          <strong>200 kW Solar Rooftop Plant</strong>,{" "}
          <strong>150 kLD Sewage Treatment Plant</strong>,{" "}
          <strong>Rainwater Harvesting</strong>, and active participation in{" "}
          <strong>Unnat Bharat Abhiyan</strong>.
        </p>
        <p>
          With <strong>30+ MoUs</strong> signed with reputed organizations
          including <strong>Tata Technologies</strong>,{" "}
          <strong>Toyota Kirloskar Motors</strong>, <strong>C-DAC</strong>,{" "}
          <strong>Cisco</strong>, <strong>IBM SkillBuild</strong>, and{" "}
          <strong>Royal Enfield</strong>, KLS VDIT has established Centres of
          Excellence in <strong>Cyber Security</strong>,{" "}
          <strong>Automobile Technology</strong>,{" "}
          <strong>Women Empowerment</strong>, and{" "}
          <strong>Microchip Technologies</strong>.
        </p>
        <p>
          KLS VDIT has been honoured with prestigious accolades such as the
          Accredited with
          <strong>
            {" "}
            NAAC A Grade , Institution of Engineers (India) Excellence Awards
            (2024 &amp; 2025)
          </strong>{" "}
          &nbsp;along with the{" "}
          <strong>Bureau of Indian Standards Award (2025)</strong>&nbsp;underscoring
          its commitment to quality, innovation, and excellence. Further
          strengthening industry-academia collaboration, KLS VDIT recently
          inaugurated the <strong>Royal Enfield Training Centre</strong>,
          serving as a regional hub for North Karnataka and Goa.
        </p>
        <p>
          Through excellence in education, research, innovation, sustainability,
          and skill development, KLS VDIT is actively contributing towards the
          vision of <strong>Viksit Bharat 2047</strong>, empowering future
          engineers, researchers, and leaders.
        </p>
        {/* <p className="mt-8">
          <strong>Dr. Vadiraj. A. Kulkarni</strong>
          <br />
          <span className="italic">Professor and Principal</span> <br />
          <span className="italic">KLS VDIT, Haliyal</span> <br />
          <a href="mailto:principal@klsvdit.edu.in">principal@klsvdit.edu.in</a>
        </p> */}
      </div>
    </div>
  </InnerLayout>
);

export default PrincipalsMessage;
